export default __webpack_public_path__ + "static/media/user.4ea45a0c.svg";